module.exports = __webpack_public_path__ + "static/img/av750c156ea54d77b97d4.3f01cd17.png";